import styled from "styled-components";

export const StyledURLListContainer = styled.div`
  padding: 0 24px;
  overflow-x: auto;
  h2 {
    margin: 0;
    font-weight: 400;
    font-size: 28px;
  }
  @media (max-width: 768px) {
    padding: 0 16px;
    h2 {
      display: none;
    }
  }
`;

export const StyledURLListTableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;
  button {
    margin: 0 !important;
  }
  @media (max-width: 768px) {
    align-items: flex-end;
    justify-content: flex-end;
  }
`;
